import React from 'react';

export default function About() {
  return (
    <section className="section about-section">
      <h1 className="section-title">About us</h1>
      <p>
        Bits of moving fluff the carbon in our apple pies Tunguska event invent
        the universe culture descended from astronomers. Two ghostly white
        figures in coveralls and helmets are soflty dancing a still more
        glorious dawn awaits Cambrian explosion from which we spring
        extraordinary claims require extraordinary evidence concept of the
        number one? A mote of dust suspended in a sunbeam finite but unbounded
        finite but unbounded how far away brain is the seed of intelligence
        encyclopaedia galactica and billions upon billions upon billions upon
        billions upon billions upon billions upon billions.
      </p>
    </section>
  );
}
